import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './widget-onboarding-info.module.css';

interface Props {
    illustrationSource: string;
    title: string;
    text: string;
}

export function WidgetOnboardingInfo(props: Props) {
    return (
        <Stack spacing={8}>
            <div className={styles['widget-illustration']}>
                <Illustration src={props.illustrationSource} />
            </div>
            <Body isBold={true}>{props.title}</Body>
            <Body size='small'>{props.text}</Body>
        </Stack>
    );
}
